module.exports = __webpack_public_path__ + "static/estamos-contigo-71c7fb7504ec839caaceb3380df05b5b.svg";